import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import SearchCard from "@/components/SearchCard";

const STEPS = [
  { n: "01", t: "INSERISCI LA TARGA", d: "Digita la targa e avvia la scansione del registro." },
  { n: "02", t: "SBLOCCA CON STRIPE", d: "35,00 € una tantum, pagamento sicuro senza abbonamenti." },
  { n: "03", t: "RICEVI IL REPORT", d: "Report tecnico completo subito, collegato alla targa." },
];

function Spotlight() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section ref={ref} className="relative overflow-hidden rounded-2xl border border-[#ff007f]/25 my-10" data-testid="spotlight-section">
      <motion.img
        src="https://images.unsplash.com/photo-1629935643068-f5b616b00655?crop=entropy&cs=srgb&fm=jpg&q=85"
        alt="Fari di un'auto sportiva nel tunnel di notte"
        style={{ y, scale: 1.18 }}
        className="w-full h-52 sm:h-64 object-cover opacity-70"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#050507]/95 via-[#050507]/55 to-transparent" />
      <div className="absolute inset-0 bg-[#ff007f]/10 mix-blend-overlay" />
      <div className="absolute inset-0 flex flex-col justify-center px-6 sm:px-8">
        <p className="font-jetmono text-[9px] tracking-[0.35em] text-[#00f0ff] mb-2">SPOTLIGHT DATI</p>
        <p className="font-orbitron font-bold text-lg sm:text-xl tracking-wider max-w-[16ch] leading-snug">
          OGNI PARTICELLA DI DATO, SOTTO CONTROLLO
        </p>
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <>
      <div className="max-w-[600px] mx-auto px-5">
        <Hero />
      </div>

      <Marquee />

      <div className="max-w-[600px] mx-auto px-5 pt-10 pb-8">
        <SearchCard />

        <section className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-10" data-testid="how-it-works-section">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.55, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="border border-white/5 bg-[#0c0c10]/70 rounded-xl p-4"
            >
              <span className="font-jetmono text-[10px] font-bold text-[#ff007f] tracking-[0.3em]">{s.n}</span>
              <h3 className="font-orbitron text-[11px] font-bold tracking-[0.15em] mt-2">{s.t}</h3>
              <p className="text-[12px] text-[#8a8a9e] leading-relaxed mt-1.5">{s.d}</p>
            </motion.div>
          ))}
        </section>

        <Spotlight />
      </div>
    </>
  );
}
